import ModalProvider from '../baseComponents/controllers/modalController/ModalProvider';
import { useRequestHandlerSettled } from '../../hooks/useRequestHandlerSettled';
import { node } from 'prop-types';
import { aliases } from '../baseComponents/controllers/modalController/aliases';
import Header from '../features/header/main/Header';
import OnboardingProvider from '../../providers/onboarding-provider';
import CopyMessage from '../features/copyMessage/CopyMessage';
import FreeSpace from '../features/freeSpace';
import { ExtraModalsProvider } from '../../providers/extra-modals-provider';

export default function MainLayout({ children }) {
  useRequestHandlerSettled();

  return (
    <>
      <ModalProvider aliases={aliases()}>
        <OnboardingProvider>
          <ExtraModalsProvider>
            <input type={'checkbox'} className={'custom-header__input'} id={'menu-burger'} />
            <div className={'main-container'}>
              <Header />
              <div className={'content-wrapper'}>{children}</div>
            </div>
          </ExtraModalsProvider>
          <FreeSpace />
        </OnboardingProvider>
      </ModalProvider>
      <CopyMessage />
    </>
  );
}

MainLayout.propTypes = {
  children: node,
};
